import { Room } from '../components/inventory/FloorPlan';

/**
 * Default room layouts for the deposit inventory system
 * Level 1: Based on Ghencea layout with 4 clickable areas + 2 visual-only areas
 * Level 2: 5 rooms (original layout)
 *
 * Coordinate system matches the 3754 × 1608 cropped floor plan image
 */

export const defaultRooms: Room[] = [
  // LEVEL 1 ROOMS - VISUAL ONLY (not clickable)
  {
    id: 'L1-EMPTY',
    name: 'Entry Room',
    level: 1,
    x: 54,
    y: 52,
    width: 859,
    height: 742,
    color: '#F3F4F6', // Gray - visual only
    isClickable: true,
    storageType: undefined, // Entry room is for orders, not inventory items
  },
  {
    id: 'L1-BATHROOM',
    name: 'Bathroom',
    level: 1,
    x: 2960,
    y: 53,
    width: 743,
    height: 325,
    color: '#E5E7EB', // Light gray - visual only
    isClickable: false,
  },

  // LEVEL 1 ROOMS - CLICKABLE AREAS
  {
    id: 'L1-AREA1',
    name: 'BL Associates Tools',
    level: 1,
    x: 963,
    y: 53,
    width: 608,
    height: 330,
    color: '#DBEAFE', // Light blue
    isClickable: true,
    shelves: [], // No specific storage locations defined
    storageType: 'consumable', // Consumable items (tools, nails, etc.) - can be restocked
  },
  {
    id: 'L1-AREA2',
    name: 'M Storage',
    level: 1,
    x: 1600,  // BL Associates (965 + 605) + gap (50) = 1600
    y: 53,
    width: 1340,
    height: 355,
    color: '#D1FAE5', // Light green
    isClickable: true,
    shelves: ['M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8', 'M9', 'M10'],
    storageType: 'consumable', // Consumable items (supplies, materials) - can be restocked
  },
  {
    id: 'L1-AREA3',
    name: 'Central Storage',
    level: 1,
    x: 925,  // x coordinate for label positioning
    y: 700,  // y coordinate for label positioning (adjusted for L-shape center)
    width: 1895,  // width for label positioning
    height: 661,  // height for label positioning
    color: '#FEF3C7', // Light yellow
    isClickable: true,
    shelves: ['R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9', 'BA1', 'BA2', 'BA3', 'BA4', 'BA5', 'BA6', 'BA7', 'BA8', 'BA9', 'BA10', 'BA11', 'BA12'],
    // Custom L-shaped polygon matching actual Central Storage area
    // Points: top-left -> top-right -> right-down -> left -> down -> bottom-left -> back to start
    polygonPoints: '961,410 2770,410 2770,790 2700,790 2700,1561 961,1561',
    storageType: 'unique', // Unique items (furniture, equipment) - deleted when taken
  },
  {
    id: 'L1-AREA4',
    name: 'Right Storage',
    level: 1,
    x: 2860,  // x coordinate for label positioning
    y: 650,   // y coordinate for label positioning (center of area)
    width: 750,  // width for label positioning
    height: 761, // height for label positioning
    color: '#E0E7FF', // Light indigo
    isClickable: true,
    shelves: ['R10', 'A1', 'A1.1', 'A1.2', 'A2', 'A2.1', 'A2.2', 'A3', 'A3.1', 'A3.2', 'A4', 'A4.1', 'A4.2', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'A11', 'A12', 'A13', 'A14', 'A15', 'A16', 'A17', 'BA'],
    // Custom polygon matching actual Right Storage area boundaries
    // Starting from top-left, going clockwise
    polygonPoints: '2770,410 3710,410 3710,1561 2700,1561 2700,790 2770,790 2770,790',
    storageType: 'unique', // Unique items (furniture, equipment) - deleted when taken
  },

  // LEVEL 2 - SINGLE LARGE ROOM
  {
    id: 'L2-STORAGE',
    name: 'Storage Area',
    level: 2,
    x: 60,
    y: 60,
    width: 680,
    height: 480,
    color: '#E0E7FF', // Light indigo
    isClickable: true,
    shelves: [], // Can add storage locations later if needed
    storageType: 'consumable', // Default to consumable for Level 2
  },
];

// Enable HMR for this module in development
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('defaultRooms.ts has been updated via HMR');
  });
}
